import React from 'react';

import { Box } from '_lib/components/Box/Box';

import { Stack } from '_lib/components/Stack/Stack';
import { HeaderBox } from '_lib/featureComponents/HeaderBox/HeaderBox';

import { HeaderTextBlock } from '_lib/featureComponents/HeaderTextBlock/HeaderTextBlock';

import { TextBlockTypography } from '_lib/featureComponents/TextBoxTypography/TextBoxTypography';

import { CompanyContext, ZoneZipContext } from '../Company.slice';
import { getLeftHighlightOkSx, getLeftHighlightWarnSx } from '../CompanyPane.styles';
import { ZoneOverrideTextBlock } from '../ZoneOverrideUtils/ZoneOverrideUtils';

export interface CompanyNotesProps {
  companyContext: CompanyContext;
  zoneZipContext: ZoneZipContext | undefined;
}

export const CompanyNotes = (props: CompanyNotesProps): React.ReactElement => {
  const { companyContext, zoneZipContext } = props;
  const { company } = companyContext;

  return (
    <Box sx={{ px: 3, py: 2 }}>
      <Stack spacing={2}>
        <HeaderTextBlock headerText='Greeting' text={company.callCenter.greetingMessage} />
        <ZoneOverrideTextBlock
          headerText='Notes'
          company={company}
          zone={zoneZipContext?.selectedZone}
          zoneCallCenterProp='notes'
        />
        <HeaderTextBlock headerText='Service Area Notes' text={company.callCenter.serviceAreaNotes} />
        <HeaderTextBlock headerText='Value' text={company.callCenter.additionalNotes} />
        <ZoneOverrideTextBlock
          headerText='Dispatch Rules'
          company={company}
          zone={zoneZipContext?.selectedZone}
          zoneCallCenterProp='dispatchRules'
        />
        <ZoneOverrideTextBlock
          headerText='Big Ticket Items'
          company={company}
          zone={zoneZipContext?.selectedZone}
          zoneCallCenterProp='bigTicketItems'
        />
        <ZoneOverrideTextBlock
          headerText='Big Ticket Item Scheduling Rules'
          company={company}
          zone={zoneZipContext?.selectedZone}
          zoneCallCenterProp='bigTicketItemRules'
        />
        <HeaderBox headerText='Work/Services NOT to Book'>
          <TextBlockTypography
            sx={(theme) => getLeftHighlightWarnSx(theme)}
            text={company.callCenter.workNotToBookRules}
          />
        </HeaderBox>
        <HeaderBox headerText='Work/Services to Book'>
          <TextBlockTypography sx={(theme) => getLeftHighlightOkSx(theme)} text={company.callCenter.workToBookRules} />
        </HeaderBox>
        <HeaderTextBlock headerText='Fee Waiver Rules' text={company.callCenter.serviceFeeWaiverRules} />
        <ZoneOverrideTextBlock
          headerText='Warranty Handling'
          company={company}
          zone={zoneZipContext?.selectedZone}
          zoneCallCenterProp='warrantyRules'
        />
        <HeaderTextBlock headerText='Current Coupons' text={company.callCenter.currentCoupons} />
        <HeaderTextBlock headerText='Discounts Offered' text={company.callCenter.discountsOffered} />
      </Stack>
    </Box>
  );
};
